module.exports = __webpack_public_path__ + "static/media/Logo.b1c42bf7.png";